"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusRequest = void 0;
var inversify_1 = require("inversify");
var string_template_1 = __importDefault(require("string-template"));
var uuid_1 = require("uuid");
var bus_event_1 = require("./bus-event");
var config_1 = require("./config");
var consts_1 = require("./consts");
var utils_1 = require("./utils");
var BusRequest = /** @class */ (function () {
    function BusRequest(config, utils, busEvent) {
        this.config = config;
        this.utils = utils;
        this.busEvent = busEvent;
    }
    /**
     * 发送通信请求，等待返回
     * @param path 唯一标记
     * @param data 数据
     * @param config 可选项
     */
    BusRequest.prototype.action = function (path, data, config) {
        if (config === void 0) { config = { timeout: 3000 }; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, prms, res, rej, requestId, timer, handle;
            return __generator(this, function (_b) {
                _a = this.utils.createPromise(), prms = _a.prms, res = _a.res, rej = _a.rej;
                requestId = uuid_1.v4();
                // 向所有iframe发送请求
                this.utils.sendToAll({ type: consts_1.MESSAGE_KEY, requestId: requestId, path: path, data: data });
                window.addEventListener('message', handle = function (event) {
                    var playload = event.data;
                    if (playload.type !== consts_1.MESSAGE_KEY || !playload.requestId)
                        return;
                    if (playload.path !== consts_1.RESPONSE_KEY || playload.requestId !== requestId)
                        return;
                    clearTimeout(timer);
                    window.removeEventListener('message', handle);
                    res(playload.data);
                });
                // 设置超时，默认3秒
                timer = setTimeout(function () {
                    rej(new Error(consts_1.MESSAGE_REQUEST_TIMEOUT));
                    window.removeEventListener('message', handle);
                }, config.timeout);
                return [2 /*return*/, prms];
            });
        });
    };
    /**
     * 注册方法，运行回调函数（注册到模块）
     * @param method 唯一标记
     * @param handler 回调函数
     */
    BusRequest.prototype.control = function (method, handler) {
        var path = this.config.id + "." + method;
        var handlers = this.busEvent.eventMap.get(path);
        if (handlers && handlers.length > 0)
            throw new Error(string_template_1.default(consts_1.MESSAGE_METHOD_CONFLICT, { method: method }));
        return this.regist(path, handler);
    };
    /**
     * 注册方法，运行回调函数
     * @param path 唯一标记
     * @param handler 回调函数
     */
    BusRequest.prototype.regist = function (path, handler) {
        var _this = this;
        return this.busEvent.on(path, function (data, event) { return __awaiter(_this, void 0, void 0, function () {
            var playload, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        playload = event.data;
                        return [4 /*yield*/, handler(data, event)];
                    case 1:
                        result = _a.sent();
                        if (playload.requestId) {
                            this.utils.sendToAll({
                                type: consts_1.MESSAGE_KEY,
                                path: consts_1.RESPONSE_KEY,
                                requestId: playload.requestId,
                                data: result
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    BusRequest = __decorate([
        inversify_1.injectable(),
        __metadata("design:paramtypes", [config_1.Config,
            utils_1.Utils,
            bus_event_1.BusEvent])
    ], BusRequest);
    return BusRequest;
}());
exports.BusRequest = BusRequest;
//# sourceMappingURL=bus-request.js.map